import React from 'react';

export function KPI({ icon, label, valor, color }) {
  return (
    <div className="kpi" style={{ borderLeftColor: color }}>
      <div className="kpi-label">
        <i className={`ti ${icon}`}></i>
        {label}
      </div>
      <div className="kpi-val">{valor}</div>
    </div>
  );
}

export function Input({ label, name, value, onChange, type = 'text', maxLength, step, disabled }) {
  return (
    <div className="form-group">
      <label>{label}</label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        step={step}
        disabled={disabled}
      />
    </div>
  );
}

export function InputDatalist({ label, name, value, onChange, opciones = [] }) {
  const listId = 'dl-' + name;
  return (
    <div className="form-group">
      <label>{label}</label>
      <input
        list={listId}
        name={name}
        value={value}
        onChange={onChange}
        autoComplete="off"
        style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px' }}
      />
      <datalist id={listId}>
        {opciones.map((op, i) => <option key={i} value={op} />)}
      </datalist>
    </div>
  );
}

export function Select({ label, name, value, onChange, opciones, disabled }) {
  return (
    <div className="form-group">
      <label>{label}</label>
      <select name={name} value={value} onChange={onChange} disabled={disabled}>
        <option value="">— Selecciona —</option>
        {opciones.map(op => {
          const val = typeof op === 'object' ? op.value : op;
          const lbl = typeof op === 'object' ? op.label : op;
          return <option key={val} value={val}>{lbl}</option>;
        })}
      </select>
    </div>
  );
}

export function SeccionLabel({ icon, children }) {
  return (
    <div style={{ fontSize: '11px', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '6px' }}>
      <i className={`ti ${icon}`}></i> {children}
    </div>
  );
}

export function blobToBase64(blob) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export function InfoCampo({ label, valor, highlight, mono }) {
  return (
    <div className="info-field">
      <div className="info-label">{label}</div>
      <div className="info-valor" style={{
        color: highlight ? '#0086ab' : '#1d3d6b',
        fontFamily: mono ? 'monospace' : 'inherit',
        fontSize: mono ? '13px' : '14px'
      }}>
        {valor}
      </div>
    </div>
  );
}

export function fileToBase64(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });
}

export function toYMDLocal(d) {
  const date = new Date(d);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function SelectSearchable({ label, name, value, onChange, opciones, disabled }) {
  const [busqueda, setBusqueda] = React.useState('');
  const [abierto, setAbierto] = React.useState(false);

  const filtradas = opciones.filter(op => {
    const val = typeof op === 'object' ? op.value : op;
    const lbl = typeof op === 'object' ? op.label : op;
    const search = busqueda.toLowerCase();
    return String(val).toLowerCase().includes(search) || String(lbl).toLowerCase().includes(search);
  });

  const seleccionada = opciones.find(op => {
    const val = typeof op === 'object' ? op.value : op;
    return String(val) === String(value);
  });
  const labelSeleccionado = seleccionada ? (typeof seleccionada === 'object' ? seleccionada.label : seleccionada) : '';

  const handleSeleccionar = (val) => {
    onChange({ target: { name, value: val } });
    setBusqueda('');
    setAbierto(false);
  };

  return (
    <div className="form-group" style={{ position: 'relative' }}>
      <label>{label}</label>
      <input
        type="text"
        placeholder="Buscar..."
        value={abierto ? busqueda : labelSeleccionado}
        onChange={(e) => { setBusqueda(e.target.value); setAbierto(true); }}
        onFocus={() => setAbierto(true)}
        disabled={disabled}
        style={{ width: '100%', padding: '8px', fontSize: '14px' }}
      />
      {abierto && filtradas.length > 0 && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          backgroundColor: '#fff',
          border: '1px solid #d1d5db',
          borderRadius: '4px',
          maxHeight: '200px',
          overflowY: 'auto',
          zIndex: 10,
          marginTop: '4px'
        }}>
          {filtradas.map((op, i) => {
            const val = typeof op === 'object' ? op.value : op;
            const lbl = typeof op === 'object' ? op.label : op;
            return (
              <div
                key={i}
                onClick={() => handleSeleccionar(val)}
                style={{
                  padding: '8px 12px',
                  cursor: 'pointer',
                  backgroundColor: String(val) === String(value) ? '#e0e7ff' : '#fff',
                  borderBottom: '1px solid #f3f4f6'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                onMouseLeave={(e) => e.target.style.backgroundColor = String(val) === String(value) ? '#e0e7ff' : '#fff'}
              >
                {lbl}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
